module.exports = __webpack_public_path__ + "img/img1.535d7fba.jpg";